import React, { useMemo } from 'react';
import clsx from 'clsx';
import styles from './styles.module.css';
/**
 * Компонент `<Badge />` отображает информацию о количестве элементов.
 * @example
 * ```jsx
 *  <Badge size="m" value={42} />
 * ```
 */
export const Badge = /*#__PURE__*/React.forwardRef(function Badge(props, ref) {
  const {
    value,
    size = 'l',
    type = 'primary',
    className,
    ...badgeProps
  } = props;
  const testId = props['data-testid'] || 'badge';
  const badgeClass = useMemo(() => clsx(styles.badge, styles[size], styles[type], className), [className, size, type]);
  const badgeValue = useMemo(() => value > 99 ? '99+' : value, [value]);
  return /*#__PURE__*/React.createElement("span", {
    role: "status",
    ...badgeProps,
    className: badgeClass,
    "data-testid": testId,
    ref: ref
  }, size !== 'xs' && (/*#__PURE__*/React.createElement("span", {
    role: "presentation",
    className: styles.badgeInner
  }, badgeValue)));
});